import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiButtonEmpty,
  EuiButton,
} from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

interface DemoProjectCardProps {
  project: {
    id: string;
    name: string;
    shortDescription: string | null;
    tenantKey: string;
    key: string;
  };
  copyProject: (projectId: string) => void;
  hasInternalPersonalSpaceOrTenant: boolean;
}

export const DemoProjectCard = ({
  project,
  copyProject,
  hasInternalPersonalSpaceOrTenant,
}: DemoProjectCardProps) => {
  const projectDynamicPath = useRouteMapContext(
    (s) => s.routeMap.PROJECT.dynamicPath,
  );
  return (
    <EuiCard
      title={project.name}
      description={project.shortDescription ?? ""}
      textAlign="left"
      paddingSize="l"
      footer={
        <EuiFlexGroup justifyContent="spaceBetween">
          <EuiFlexItem grow={false}>
            <EuiButtonEmpty
              size="s"
              aria-label="Copy project"
              iconType={"copy"}
              onClick={() => copyProject(project.id)}
              disabled={!hasInternalPersonalSpaceOrTenant}
            >
              Make a copy
            </EuiButtonEmpty>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton
              size="s"
              aria-label="Go to demo project"
              onClick={() =>
                projectDynamicPath({
                  tenantKey: project.tenantKey,
                  projectKey: project.key,
                }).navigateTo()
              }
            >
              View project
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      }
    />
  );
};
